/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Text, Flex, Box, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { gql, useLazyQuery } from '@apollo/client';
import moment from 'moment/moment';
import DownloadAndViewButton from '../../Files/DownloadAndViewButton';
import UserDislayNameById from '../../UserDislayNameById';

export const Q_REPORT_HISTORIES = gql`
	query GetEWSReportHistories($id: String!, $period: [EarlyWarningTypeStatement!]!, $category: [EarlyWarningGroupTypeStatement!]!) {
		getEWSReportHistories(id: $id, period: $period, category: $category)
	}
`;

function EWSEditHistoryModal({ id, period = null, category = null, isOpen = false, onClose = () => null }) {
	const { t } = useTranslation();

	const [loadHistories, { data, loading, error }] = useLazyQuery(Q_REPORT_HISTORIES, {
		fetchPolicy: 'network-only',
	});

	useEffect(() => {
		if (isOpen && id && period && category) {
			loadHistories({
				variables: {
					id,
					period,
					category,
				},
			});
		}
	}, [isOpen, id, period, category]);

	const histories = Array.isArray(data?.getEWSReportHistories) ? data?.getEWSReportHistories : [];

	return (
		<Modal isOpen={isOpen} onClose={onClose} scrollBehavior="inside" size="md">
			<ModalOverlay />
			<ModalContent pb={6}>
				<ModalHeader>{t('Logs')}</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					{loading && (
						<Text fontSize="sm" fontWeight="semibold" color="gray.600">
							{t('Loading')}
						</Text>
					)}

					{!loading && !error && histories.length === 0 && (
						<Text fontSize="sm" fontWeight="semibold" color="gray.600">
							{t('No Data')}
						</Text>
					)}

					{!loading &&
						!error &&
						histories?.length > 0 &&
						histories?.map((item, index) => (
							<Box key={index} borderWidth="1px" borderRadius="md" p={4} mb={4}>
								<Text fontSize="sm" fontWeight="bold" mb={3}>
									{t('History')} #{index + 1}
								</Text>
								<VStack width="100%" spacing={2}>
									<Flex justify="space-between" align="start" width="100%">
										<Text fontSize="sm" color="gray.600" fontWeight="600">
											{t('Allow Editing')}
										</Text>
										<Text fontSize="sm" textAlign="right" maxW="60%">
											{item?.allowedAt ? moment(item.allowedAt).format('DD MMM YYYY, h:mm A') : '-'}
										</Text>
									</Flex>

									<Flex justify="space-between" align="start" width="100%">
										<Text fontSize="sm" color="gray.600" fontWeight="600">
											{t('Allowed By')}
										</Text>
										<Text fontSize="sm" textAlign="right" maxW="60%">
											<UserDislayNameById id={item?.allowedBy} />
										</Text>
									</Flex>

									<Flex justify="space-between" align="start" width="100%">
										<Text fontSize="sm" color="gray.600" fontWeight="600">
											{t('Due Date')}
										</Text>
										<Text fontSize="sm" textAlign="right" maxW="60%">
											{item?.editingDueDate ? moment(item.editingDueDate).format('DD MMM YYYY, h:mm A') : '-'}
										</Text>
									</Flex>

									<Flex justify="space-between" align="start" width="100%">
										<Text fontSize="sm" color="gray.600" fontWeight="600">
											{t('Description (Company)')}
										</Text>
										<Text fontSize="sm" textAlign="right" maxW="60%">
											{item?.editingDescription || '-'}
										</Text>
									</Flex>

									<Box width="100%" height={1} mt={4} mb={4} borderBottomWidth="1px" borderBottomStyle="dashed" />

									<Flex justify="space-between" align="start" width="100%">
										<Text fontSize="sm" color="gray.600" fontWeight="600">
											{t('Proposal/Letter In')}
										</Text>
										<Text fontSize="sm" textAlign="right" maxW="60%">
											{item?.proposalNumber || '-'}
										</Text>
									</Flex>

									<Flex justify="space-between" align="start" width="100%">
										<Text fontSize="sm" color="gray.600" fontWeight="600">
											{t('np or rp')}
										</Text>
										<Text fontSize="sm" textAlign="right" maxW="60%">
											{item?.npReportNumber || '-'}
										</Text>
									</Flex>

									<Flex justify="space-between" align="start" width="100%">
										<Text fontSize="sm" color="gray.600" fontWeight="600">
											{t('Note (Official)')}
										</Text>
										<Text fontSize="sm" textAlign="right" maxW="60%">
											{item?.note || '-'}
										</Text>
									</Flex>

									<Flex justify="space-between" align="start" width="100%">
										<Text fontSize="sm" color="gray.600" fontWeight="600">
											{t('Attachment')}
										</Text>
										<DownloadAndViewButton marginLeft={0} url={item?.attachmentFile?.url} size={item?.attachmentFile?.size} />
									</Flex>
								</VStack>
							</Box>
						))}
				</ModalBody>
			</ModalContent>
		</Modal>
	);
}

export default EWSEditHistoryModal;
